export enum CHECKOUT_STEPS {
  CART = 'cart',
  ADDRESS = 'address',
  SHIPPING = 'shipping',
  PAYMENT = 'payment',
  CONFIRM = 'confirm',
}
/**
 * We've added enum for this feature to separate laptop logics to mobile.
 * we might as well merge one into another when we implement in full-stretch
 * @see https://petsdeli.atlassian.net/browse/PT-3731
 */
export enum CHECKOUT_STEPS_MOBILE {
  ADDRESS = 'address',
  SHIPPING = 'shipping',
  PAYMENT = 'payment',
}
